/* unplugin-vue-components disabled */import __unplugin_components_13 from '~icons/custom/undone';
import __unplugin_components_12 from '~icons/custom/completed';
import { ElForm as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElEmpty as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElTooltip as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import __unplugin_components_8 from '~icons/ep/question-filled';
import { ElInput as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import __unplugin_components_6 from '~icons/ep/upload';
import { ElFormItem as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSwitch as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_2 from '~icons/ep/document';
import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0cc30c90"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存");
const _hoisted_2 = {
  class: "cascader-box"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "登录方式", -1));
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "参数配置", -1));
const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  key: 0,
  class: "operate-desc"
};
const _hoisted_12 = /*#__PURE__*/_createTextVNode("请按 ");
const _hoisted_13 = ["href"];
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 操作说明");
const _hoisted_15 = /*#__PURE__*/_createTextVNode("提交审核并获取参数 ");
const _hoisted_16 = {
  key: 0,
  class: "params-box"
};
const _hoisted_17 = /*#__PURE__*/_createTextVNode("BusinessId");
const _hoisted_18 = {
  class: "flex items-center"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "marginL10"
}, "上传p8文件，用于生成appSecret", -1));
const _hoisted_22 = {
  key: 0,
  class: "content"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#4a6cef"
  }
}, " 若需要对改渠道的【邮箱设置】以及【模版配置】进行配置，请在【官方全球渠道配置】-【邮箱管理】中的该渠道操作 ", -1));
const _hoisted_24 = {
  class: "marginT20"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "邮箱设置"), /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "应用于发送验证码")], -1));
const _hoisted_26 = {
  class: "marginT10 flex items-center"
};
const _hoisted_27 = {
  class: "marginL10"
};
const _hoisted_28 = {
  class: "marginT20"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "邮箱验证码模板"), /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "通过验证码模板给玩家发送邮件")], -1));
const _hoisted_30 = {
  class: "marginT10 flex items-center"
};
const _hoisted_31 = {
  class: "marginL10"
};
const _hoisted_32 = {
  key: 0,
  id: "input-file",
  class: "input-file",
  type: "file"
};
import UseConfig from '../configHook';
import UseLoginPay from '../loginPayHooks';
import { apiUsdkGetEmailConfigStatus, apiUsdkSaveGlobalLoginSwitchConf } from '@/api/usdk';
import TipsModal from '@ultra/share/components/UTipsModal/index.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    gid: {
      type: Number,
      required: true,
      default: 0
    },
    channel: {
      type: Object,
      default: () => ({})
    },
    loginParams: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      globalLogin,
      globalLoginIcon,
      GlobalLoginConfigDict
    } = UseConfig();
    const {
      rules
    } = UseLoginPay();
    // 初始化
    const form = ref({});
    const showInputFile = ref(true);
    globalLogin.forEach(item => {
      form.value[item.key] = {
        val: 0
      };
      form.value[item.key + 'Conf'] = {};
    });
    watch(() => props.loginParams, _params => {
      if (_params) {
        _params = JSON.parse(JSON.stringify(_params));
        let params = {
          ..._params
        };
        if (params.usdk_cid) {
          let typeArr = ['twitter', 'oppo', 'line', 'apple'];
          typeArr.forEach(t => {
            if (!params[t + 'Conf']) {
              params[t + 'Conf'] = {};
              GlobalLoginConfigDict[t].configKeys.forEach(p => {
                params[t + 'Conf'][p.key] = '';
              });
            }
          });
          for (let key in params) {
            if (params[key].val) {
              params[key].val = Number(params[key].val);
            }
          }
          form.value = {
            ...params
          };
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    const dialogVisible = ref(false);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    // 参数配置说明
    const tipsModal = ref();
    const handleShowDesc = data => {
      var _tipsModal$value;
      (_tipsModal$value = tipsModal.value) === null || _tipsModal$value === void 0 ? void 0 : _tipsModal$value.show(data.html);
    };
    // 开关参数配置
    const ruleForm = ref();
    const handleSubmit = () => {
      var _ruleForm$value;
      (_ruleForm$value = ruleForm.value) === null || _ruleForm$value === void 0 ? void 0 : _ruleForm$value.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(form.value));
          console.log(params);
          let switchList = [];
          let switchConfList = [];
          globalLogin.forEach(item => {
            // if (params['val_' + item.type] == 1) {
            // 所有开关 + 打开的参数
            const obj = params[item.key];
            let switchObj = {
              type: item.type,
              ...obj
            };
            if (GlobalLoginConfigDict[item.type] && obj.val == 1) {
              params[item.key + 'Conf'] && switchConfList.push(params[item.key + 'Conf']);
            }
            switchList.push(switchObj);
            // }
          });
          switchList.push(form.value.facebookBusinessId);
          ElMessageBox.confirm(`你正在编辑修改${props.channel.name}渠道登录开关/参数，修改后将直接立即影响线上游戏登录方式，请务必确认操作无误后再保存，否则因此导致的线上游戏登录事故后果自负！`, '提示', {
            customStyle: {
              width: '650px'
            },
            confirmButtonText: '取消，不保存',
            cancelButtonText: '确认保存',
            dangerouslyUseHTMLString: true,
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            // to do
          }).catch(action => {
            if (action === 'cancel') {
              confirmLoading.value = true;
              return apiUsdkSaveGlobalLoginSwitchConf({
                gid: props.gid,
                cid: props.channel.cid,
                switchList,
                switchConfList
              }).then(res => {
                if (res.code === 0) {
                  handleClose();
                  emits('ok');
                }
              }).finally(() => {
                confirmLoading.value = false;
              });
            }
          });
        }
      });
    };
    const currentLogin = ref({});
    const currentEmailConfigStatus = ref({
      isBindMail: '',
      mailTemplate: ''
    });
    const handleClick = async params => {
      console.log('pro', props.channel);
      currentLogin.value = params;
      if (params.type === 16) {
        const res = await apiUsdkGetEmailConfigStatus({
          var: props.loginParams.email.var,
          surfix: props.loginParams.email.surfix,
          product_id: props.channel.globalLogin.productId
        });
        currentEmailConfigStatus.value = res.data;
      }
    };
    // 保存操作
    const confirmLoading = ref(false);
    // 解析.p8文件获取appSecret
    const onChangeAppSecret = p => {
      let inputEl = document.getElementById('input-file');
      inputEl.onchange = e => {
        let file = e.target.files[0] || null;
        if (!file) return;
        let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
        console.log(fileExtension);
        if (fileExtension !== 'p8') {
          ElMessage('请上传.p8结尾的文件');
          return;
        }
        let reader = new FileReader();
        reader.readAsText(file, 'UTF-8');
        reader.onload = evt => {
          let fileString = evt.target.result;
          if (!fileString.includes('-----BEGIN PRIVATE KEY-----')) {
            ElMessage('文件格式不对，请重新上传');
            return;
          }
          fileString = fileString.replace('-----BEGIN PRIVATE KEY-----', '');
          fileString = fileString.replace('-----END PRIVATE KEY-----', '');
          fileString = fileString.replace(/\r\n/g, '');
          fileString = fileString.replace(/\n/g, '');
          form.value[currentLogin.value.key + 'Conf'][p.key] = fileString;
          ElMessage.success('解析成功！');
          showInputFile.value = false;
          setTimeout(() => {
            showInputFile.value = true;
          }, 200);
        };
      };
      inputEl.click();
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_checkbox = __unplugin_components_1;
      const _component_i_ep_Document = __unplugin_components_2;
      const _component_el_icon = __unplugin_components_3;
      const _component_el_switch = __unplugin_components_4;
      const _component_el_form_item = __unplugin_components_5;
      const _component_i_ep_Upload = __unplugin_components_6;
      const _component_el_input = __unplugin_components_7;
      const _component_i_ep_question_filled = __unplugin_components_8;
      const _component_el_tooltip = __unplugin_components_9;
      const _component_el_empty = __unplugin_components_10;
      const _component_el_form = __unplugin_components_11;
      const _component_i_custom_completed = __unplugin_components_12;
      const _component_i_custom_undone = __unplugin_components_13;
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#globalLogin"
      }, [_createVNode(_component_el_button, {
        loading: confirmLoading.value,
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }, 8, ["loading"])])), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalLogin), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.type,
          class: _normalizeClass(['check-item', currentLogin.value.type === item.type ? 'active-check-item' : '']),
          onClick: $event => handleClick(item)
        }, [_createVNode(_component_el_checkbox, {
          modelValue: form.value[item.key].val,
          "onUpdate:modelValue": $event => form.value[item.key].val = $event,
          "false-label": 0,
          "true-label": 1,
          class: "marginR5"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("img", {
          src: _unref(globalLoginIcon)[item.key],
          alt: "",
          style: {
            "margin-right": "3px"
          },
          width: "16"
        }, null, 8, _hoisted_7), _createTextVNode(_toDisplayString(item.label), 1)], 10, _hoisted_6);
      }), 128))])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [currentLogin.value.operateDesc ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("a", {
        href: currentLogin.value.operateDesc,
        target: "_blank"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_i_ep_Document)]),
        _: 1
      }), _hoisted_14], 8, _hoisted_13), _hoisted_15])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
        ref_key: "ruleForm",
        ref: ruleForm,
        model: form.value,
        "label-width": "150px"
      }, {
        default: _withCtx(() => [currentLogin.value.key === 'facebook' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [_hoisted_17]),
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: form.value.facebookBusinessId.val,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.facebookBusinessId.val = $event),
            "active-value": 1,
            "inactive-value": 0
          }, null, 8, ["modelValue"])]),
          _: 1
        })])) : _createCommentVNode("", true), _unref(GlobalLoginConfigDict)[currentLogin.value.type] ? (_openBlock(), _createElementBlock("div", {
          key: currentLogin.value.type + 1,
          class: "params-box"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GlobalLoginConfigDict)[currentLogin.value.type].configKeys, p => {
          return _openBlock(), _createBlock(_component_el_form_item, {
            key: p.key,
            label: p.label,
            prop: [currentLogin.value.key + 'Conf'] + '.' + [p.key],
            rules: _unref(rules)(p)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [currentLogin.value.key === 'apple' && p.key === 'appSecret' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_button, {
              class: "upload-btn",
              plain: "",
              type: "primary",
              onClick: $event => onChangeAppSecret(p)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_i_ep_Upload)]),
                _: 1
              }), _createTextVNode(" " + _toDisplayString(form.value[currentLogin.value.key + 'Conf'][p.key] ? '重新上传' : '点击上传'), 1)]),
              _: 2
            }, 1032, ["onClick"]), _hoisted_21]), _createVNode(_component_el_input, {
              modelValue: form.value[currentLogin.value.key + 'Conf'][p.key],
              "onUpdate:modelValue": $event => form.value[currentLogin.value.key + 'Conf'][p.key] = $event,
              disabled: "",
              placeholder: "上传P8文件后自动生成"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])) : (_openBlock(), _createBlock(_component_el_input, {
              key: 1,
              modelValue: form.value[currentLogin.value.key + 'Conf'][p.key],
              "onUpdate:modelValue": $event => form.value[currentLogin.value.key + 'Conf'][p.key] = $event,
              placeholder: `请输入${p.label}`
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])), p.tips ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 2
            }, {
              content: _withCtx(() => [_createTextVNode(_toDisplayString(p.tips), 1)]),
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                size: 20,
                class: "marginL10 cp",
                color: "#f59a23"
              }, {
                default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
                _: 1
              })]),
              _: 2
            }, 1024)) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 3,
              size: 20,
              class: "marginL10 cp",
              color: "#f59a23",
              onClick: $event => handleShowDesc(p)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
              _: 2
            }, 1032, ["onClick"]))])]),
            _: 2
          }, 1032, ["label", "prop", "rules"]);
        }), 128))])) : _createCommentVNode("", true), !currentLogin.value.type || !_unref(GlobalLoginConfigDict)[currentLogin.value.type] && currentLogin.value.key !== 'facebook' && currentLogin.value.key !== 'email' ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 2,
          description: "不需要配置参数"
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])]), currentLogin.value.key === 'email' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [currentEmailConfigStatus.value.isBindMail ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        size: "16px"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_completed)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        size: "16px"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_undone)]),
        _: 1
      })), _createElementVNode("span", _hoisted_27, _toDisplayString(currentEmailConfigStatus.value.isBindMail ? '已配置' : '未配置'), 1)])]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [currentEmailConfigStatus.value.mailTemplate ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        size: "16px"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_completed)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        size: "16px"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_undone)]),
        _: 1
      })), _createElementVNode("span", _hoisted_31, _toDisplayString(currentEmailConfigStatus.value.mailTemplate ? '已配置' : '未配置'), 1)])])])) : _createCommentVNode("", true)])]), _createVNode(TipsModal, {
        ref_key: "tipsModal",
        ref: tipsModal
      }, null, 512), showInputFile.value ? (_openBlock(), _createElementBlock("input", _hoisted_32)) : _createCommentVNode("", true)], 64);
    };
  }
});